import pdfPackage from 'pdfjs-dist/package.json';

export const pdfAssetsBase = `${process.env.PUBLIC_URL || ''}/pdfjs/${pdfPackage.version}/`;

// The official webpack entry emits its module worker into our own static build.
export const loadPdfJs = () => import('pdfjs-dist/legacy/webpack.mjs');

export async function readPdfBytes(data: Blob | ArrayBuffer): Promise<Uint8Array> {
  if (data instanceof ArrayBuffer) return new Uint8Array(data);
  if (typeof data.arrayBuffer === 'function') return new Uint8Array(await data.arrayBuffer());
  const buffer = await new Promise<ArrayBuffer>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => reader.result instanceof ArrayBuffer ? resolve(reader.result) : reject(new Error('Не удалось прочитать PDF'));
    reader.onerror = () => reject(new Error('Не удалось прочитать PDF'));
    reader.onabort = () => reject(new Error('Чтение PDF отменено'));
    reader.readAsArrayBuffer(data);
  });
  return new Uint8Array(buffer);
}
